
function AlertComponent() {
    let alertBanner = document.querySelector('.alert-banner');
    if (alertBanner === null) {
        return;
    }
    let activeAlert = 0;
    let dots = alertBanner.querySelectorAll('.dot');
    let alerts = alertBanner.querySelector('.alerts');
    function SetAlert(alertIndex) {
        dots[activeAlert].classList.remove('active');
        activeAlert = alertIndex;
        dots[activeAlert].classList.add('active');
    }
    if (document.querySelector('.hero') === null) {
        const AutomaticScrollDelay = 4500;
        function ScrollAutomatically() {
            let alert = alerts.children[(activeAlert + 1) % alerts.children.length];
            alerts.scrollTo({ 'left': alert.offsetLeft, 'behavior': 'smooth' });
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        }
        let scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        alerts.addEventListener('scroll', function() {
            window.clearTimeout(scrollAutomatically)
            scrollAutomatically = window.setTimeout(ScrollAutomatically, AutomaticScrollDelay);
        });
    }
    alerts.addEventListener('scroll', function() {
        SetAlert(Math.round(alerts.scrollLeft/alerts.offsetWidth));
    });
    let alertCount = alerts.children.length;
    for (let index = 0; index < alertCount; index += 1) {
        let alert = alerts.children[index]
        let dot = dots[index];
        dot.addEventListener('click', function() {
            alerts.scrollTo({ "left": alert.offsetLeft, "behavior": 'smooth' });
        });
        let dismiss = alert.querySelector('.dismiss-button');
        dismiss.addEventListener('click', function(event) {
            let alertId = alert.getAttribute('data-id');
            window.fetch(new URL("/search/alertBannerComponentSearch", window.location), {
                "method": "POST",
                "body": new URLSearchParams([["dismiss", alertId]]),
            });
            alert.remove();
            dot.remove();
            dots = alertBanner.querySelectorAll('.dot');
            alertCount -= 1;
            if (alertCount === 0) {
                alertBanner.remove();
            }
            else {
                SetAlert(Math.round(alerts.scrollLeft/alerts.offsetWidth));
            }
            event.preventDefault();
        });
    }
    return;
    //if (!('alerts' in window.sessionStorage)) {
    //    window.sessionStorage.setItem('alerts', JSON.stringify({ dismissed: [] }));
    //}
    //let { dismissed } = JSON.parse(window.sessionStorage.getItem('alerts'));
    //let previous = alertBanner.querySelector('.previous');
    //let next = alertBanner.querySelector('.next');
    //let alerts = alertBanner.querySelector('.alerts');
    //
    //let activeAlert = 0;
    //
    //    /*if (activeAlert === 0) {
    //        previous.setAttribute('hidden', 'hidden');
    //    }
    //    else {
    //        previous.removeAttribute('hidden');
    //    }
    //    if (activeAlert === alerts.children.length - 1) {
    //        next.setAttribute('hidden', 'hidden');
    //    }
    //    else {
    //        next.removeAttribute('hidden');
    //    }*/
    //}
    ///*previous.addEventListener('click', function() {
    //    if (activeAlert !== 0) {
    //        let alert = alerts.children[activeAlert - 1];
    //        alerts.scrollTo({ 'left': alert.offsetLeft, 'behavior': 'smooth' });
    //    }
    //});
    //next.addEventListener('click', function() {
    //    if (activeAlert !== alerts.children.length - 1) {
    //        let alert = alerts.children[activeAlert + 1];
    //        alerts.scrollTo({ 'left': alert.offsetLeft, 'behavior': 'smooth' });
    //    }
    //});*/
    ///*if (activeAlert === 0) {
    //    previous.setAttribute('hidden', 'hidden');
    //}
    //else {
    //    previous.removeAttribute('hidden');
    //}
    //if (activeAlert === alerts.children.length - 1) {
    //    next.setAttribute('hidden', 'hidden');
    //}
    //else {
    //    next.removeAttribute('hidden');
    //}*/
    //let alertCount = alerts.children.length;
    //console.log("alertCount: ", alertCount);
    //for (let index = alertCount - 1; 0 <= index; index -= 1) {
    //    let alert = alerts.children[index]
    //    let dot = dots[index];
    //    let alertId = alert.getAttribute('data-id');
    //    if (!dismissed.includes(alertId)) {
    //        alert.removeAttribute('hidden');
    //        dot.removeAttribute('hidden');
    //        delete dots[index];
    //    }
    //    else {
    //        alert.remove();
    //        dot.remove();
    //        alertCount -= 1;
    //    }
    //    let dismissButton = alert.querySelector('.dismiss-button');
    //    dismissButton.addEventListener('click', function() {
    //        alert.remove();
    //        dot.remove();
    //        //delete dots[index];
    //        dismissed.push(alertId);
    //        window.sessionStorage.setItem('alerts', JSON.stringify({ dismissed }));
    //        alertCount -= 1;
    //        if (alertCount === 0) {
    //            alertBanner.remove();
    //        }
    //        else {
    //            SetAlert(Math.round(alerts.scrollLeft/alerts.offsetWidth));
    //        }
    //    });
    //}
    //if (alertCount !== 0) {
    //    /*alertBanner.removeAttribute('hidden');*/
    //    alertBanner.querySelector('.dot').classList.add('active');
    //}
    //else {
    //    alertBanner.remove();
    //}
    //let activeDot = dots[0];
    ////console.log("active: ", dots);
    ////activeDot.classList.add('active');
    //Array.prototype.forEach.call(dots, function(dot, index) {
    //    dot.addEventListener('click', function() {
    //        /*SetAlert(index);*/
    //        activeDot.classList.remove('active');
    //        activeDot = dot;
    //        activeDot.classList.add('active');
    //        let alert = alerts.children[index];
    //        console.log(dot, " clicked ", alert);
    //        alerts.scrollTo({ 'left': alert.offsetLeft, 'behavior': 'smooth' });
    //    });
    //});
    ///*SetAlert(0);*/
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AlertComponent);
}
else {
    AlertComponent();
}
